import { User } from '../auth/auth.state'
import { SalaryComponent } from '../salary-components/salary-components.state'

//For components
export enum SalaryMode {
  CREATE = 'create',
  REVISE = 'revise',
  UPDATE = 'update'
}

export enum CTCBasis {
  ANNUALLY = 'annually',
  QUARTERLY = 'quarterly',
  MONTHLY = 'monthly',
  WEEKLY = 'weekly',
  DAILY = 'daily'
}

export interface CTC {
  basis: CTCBasis
  currency: string
  ctc: number
  effectiveFrom: string
  payoutFrom: string
}

export interface StatutoryCompliances {
  pf: boolean
  eps: boolean
  employerCapping: boolean
  esi: boolean
  lwf: boolean
  pt: boolean
}

export type ExtendedSalaryComponent = SalaryComponent & {
  employerContribution?: number
  employeeContribution?: number
}

export interface SalaryData {
  basic: number
  hra: number
  pf: number
  otherComponents: ExtendedSalaryComponent[] | []
  specialAllowance: number
  tds?: number
  lop?: number
}

export interface EmployeeSalary {
  id?: string | null | undefined
  belongsTo: string | null
  employeeId: string
  statutoryCompliances: StatutoryCompliances
  ctcValue: number
  effectiveFrom: string
  payoutFrom: string
  ctc: CTC
  salaryData: SalaryData
  updatedAt?: Date | null
  createdAt?: Date | null
  deletedAt?: Date | null
}

export interface EmployeeSalaryWithUser extends EmployeeSalary {
  id: string
  employee: User
}

export interface EmployeeSalaryState {
  employeeSalary: EmployeeSalary
  revisedSalary: EmployeeSalary
  allSalaries: EmployeeSalary[]
  allSalariesByBusiness: EmployeeSalaryWithUser[] | null
  loading: boolean
  error: string | null
}

export const initialState: EmployeeSalaryState = {
  employeeSalary: createInitialSalaryDraft(),
  revisedSalary: createInitialSalaryDraft(),
  allSalaries: [],
  allSalariesByBusiness: null,
  loading: false,
  error: null
}

// Helper function to create an empty draft structure
export function createInitialSalaryDraft(): EmployeeSalary {
  return {
    belongsTo: '' as string | null,
    employeeId: '' as string,
    statutoryCompliances: {
      pf: false,
      eps: false,
      employerCapping: false,
      esi: false,
      lwf: false,
      pt: false
    },
    ctcValue: 0,
    effectiveFrom: '',
    payoutFrom: '',
    ctc: {
      basis: CTCBasis.ANNUALLY,
      currency: 'INR',
      ctc: 0,
      effectiveFrom: '',
      payoutFrom: ''
    },
    salaryData: {
      basic: 0,
      hra: 0,
      pf: 0,
      otherComponents: [],
      specialAllowance: 0
    }
  }
}
